export default [
  {
    path: "/hospital",
    component: () => import('../page/hos/index.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/hos.js